import { render, staticRenderFns } from "./MarketingCarousel.vue?vue&type=template&id=6a40200d"
import script from "./MarketingCarousel.vue?vue&type=script&lang=ts"
export * from "./MarketingCarousel.vue?vue&type=script&lang=ts"
import style0 from "./MarketingCarousel.vue?vue&type=style&index=0&id=6a40200d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports